/**
 * Stripe SaaS palestra → FitGymTrack (checkout redirect, non Elements).
 */
export function createGymStripeApi(getAuthenticatedApi) {
    return {
        async createCheckout(planId) {
            const api = getAuthenticatedApi();
            const res = await api.post('/gym_billing.php?action=create_checkout', { plan_id: planId });
            return res.data;
        },

        async openBillingPortal() {
            const api = getAuthenticatedApi();
            const res = await api.post('/gym_billing.php?action=billing_portal', {});
            return res.data;
        },

        async confirmCheckout(sessionId) {
            const api = getAuthenticatedApi();
            const res = await api.post('/gym_billing.php?action=confirm_checkout', {
                session_id: sessionId,
            });
            return res.data;
        },

        async cancelSubscriptionRenewal() {
            const api = getAuthenticatedApi();
            const res = await api.post('/gym_billing.php?action=cancel_subscription', {});
            return res.data;
        },

        async resumeSubscriptionRenewal() {
            const api = getAuthenticatedApi();
            const res = await api.post('/gym_billing.php?action=resume_subscription', {});
            return res.data;
        },
    };
}
